<div [formGroup]="timeEntryCategoryForm" class="form flex flex-col">
  <nx-edit-text-input
    formControlName="name"
    placeholder="Maschine bedienen"
    label="Name">
  </nx-edit-text-input>
  <nx-edit-color-input
    formControlName="color"
    label="Farbe">
  </nx-edit-color-input>
  <nx-edit-text-input
    formControlName="externalId"
    placeholder="operateMachine"
    label="Externe ID">
  </nx-edit-text-input>
  <nx-checkbox-text-input
    formControlName="enabled"
    label="Aktiv">
  </nx-checkbox-text-input>
<div>